import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const LogReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="logReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />

      <FormField
        controlId="logReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />

      <FormField
        controlId="logReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />

      <FormField
        controlId="logReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.parameterizedBy?.message}
      />

      <FormField
        controlId="logReaderFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.format?.message}
      />

      <FormField
        controlId="logReaderFormScroll"
        label="scroll"
        name="properties.scroll"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />

      <FormField
        controlId="logReaderFormTenantKey"
        label="tenantKey"
        name="properties.tenantKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.tenantKey?.message}
      />

      <FormField
        controlId="logReaderFormEnvironmentKey"
        label="environmentKey"
        name="properties.environmentKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.environmentKey?.message}
      />

      <FormField
        controlId="logReaderFormWorkspaceKey"
        label="workspaceKey"
        name="properties.workspaceKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.workspaceKey?.message}
      />

      <FormField
        controlId="logReaderFormTriggerType"
        label="triggerType"
        name="properties.triggerType"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.triggerType?.message}
      />

      <FormField
        controlId="logReaderFormCreatedDate"
        label="createdDate"
        name="properties.createdDate"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.createdDate?.message}
      />

      <FormField
        controlId="logReaderFormRecipeName"
        label="recipeName"
        name="properties.recipeName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.recipeName?.message}
      />

      <FormField
        controlId="logReaderFormCategory"
        label="category"
        name="properties.category"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.category?.message}
      />

      <FormField
        controlId="logReaderFormFromCreatedDate"
        label="fromCreatedDate"
        name="properties.fromCreatedDate"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.fromCreatedDate?.message}
      />

      <FormField
        controlId="logReaderFormToCreatedDate"
        label="toCreatedDate"
        name="properties.toCreatedDate"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.toCreatedDate?.message}
      />

      <SchemaEditor form={form} id={id} />

      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default LogReaderForm;
